import {AuthRepository} from '../repositories/AuthRepository';
import {TwoFactorVerifyResponse} from '../entities/User';

export class Verify2FACodeUseCase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(code: string, token?: string): Promise<TwoFactorVerifyResponse> {
    if (!code || !code.trim()) {
      throw new Error('El código de verificación es requerido');
    }

    // Remove any spaces or dashes from the code
    const cleanCode = code.trim().replace(/[\s-]/g, '');

    // Validate code length (should be 6 digits)
    if (cleanCode.length !== 6) {
      throw new Error('El código debe tener 6 dígitos');
    }

    // Validate that code contains only digits
    if (!/^\d+$/.test(cleanCode)) {
      throw new Error('El código debe contener solo números');
    }

    return await this.authRepository.verify2FACode(cleanCode, token);
  }
}

